import { createContext, useContext } from 'react';

export const WindowManagerContext = createContext(null);

export const useWindowManagerContext = () => useContext(WindowManagerContext);
